import { useEffect, useState } from "react";
import { FiLoader } from "react-icons/fi";
import { apiFetch } from "../utils/apiFetch";

export default function PlatformCheckoutConfirmation({ subscriptionId, onDone }) {
  const [state, setState] = useState("checking");
  const [error, setError] = useState("");
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    let timer;
    const started = Date.now();
    setState("checking"); setError("");
    const poll = async () => {
      try {
        const response = await apiFetch(`${process.env.API_URL}/api/subscriptions/checkout-status/${encodeURIComponent(subscriptionId)}`, { signal: controller.signal });
        const data = await response.json();
        if (!response.ok) throw Error(data.message || "Could not check payment status.");
        if (controller.signal.aborted) return;
        if (data.confirmed) { setState("confirmed"); return; }
        if (["unpaid", "failed", "ended", "attention"].includes(data.checkoutState)) { setState(data.checkoutState); return; }
        if (Date.now() - started >= 120000) { setState("pending"); return; }
        timer = setTimeout(poll, 5000);
      } catch (error) {
        if (!controller.signal.aborted) { setError(error.message); setState("error"); }
      }
    };
    poll();
    return () => { controller.abort(); clearTimeout(timer); };
  }, [subscriptionId, attempt]);
  const messages = {
    checking: "Confirming your platform subscription. Please do not pay again.",
    confirmed: "Your platform subscription is confirmed.",
    unpaid: "",
    failed: "The payment attempt failed. You can try payment again.",
    ended: "The previous subscription has ended. You can choose a plan again.",
    attention: "Your subscription needs attention. Manage it in user settings or contact support before making another payment.",
    pending: "Payment confirmation is taking longer than expected. Please do not pay again. You can check again shortly.",
  };
  return <main className="flex min-h-dvh items-center justify-center bg-[var(--app-surface)] px-6 text-[var(--app-text)]"><section className="w-full max-w-md space-y-5 text-center">
    <h1 className="text-xl font-semibold">Platform subscription</h1>
    <div role="status" className="space-y-4">{state === "checking" && <FiLoader aria-label="Checking payment status" className="mx-auto h-8 w-8 animate-spin" />}{messages[state] && <p>{messages[state]}</p>}</div>
    {error && <p role="alert" className="text-sm text-red-500">{error}</p>}
    {["pending", "error", "unpaid"].includes(state) && <button onClick={() => setAttempt(value => value + 1)} className="min-h-11 rounded-md border border-[var(--app-border)] px-4">Check payment status</button>}
    {["unpaid", "failed", "ended", "confirmed", "attention"].includes(state) && <button onClick={() => onDone(state)} className="mx-auto block min-h-11 rounded-md bg-[var(--app-text)] px-4 text-[var(--app-surface)]">{state === "confirmed" ? "Continue" : state === "attention" ? "Subscription settings" : state === "failed" ? "Try payment again" : "Back to plans"}</button>}
  </section></main>;
}
